import { render } from "./Project2View.vue?vue&type=template&id=56ca5852&scoped=true&ts=true"
import script from "./Project2View.vue?vue&type=script&lang=ts"
export * from "./Project2View.vue?vue&type=script&lang=ts"

import "./Project2View.vue?vue&type=style&index=0&id=56ca5852&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56ca5852"]])

export default __exports__